import * as React from "react";

function ConectaZapColoredIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width={40}
        height={40}
        rx={8}
        fill="url(#paint0_linear_21238_5679)"
      />
      <path
        d="M34.104 18.908a9.539 9.539 0 10-6.767 9.813l1.942 1.062a1.385 1.385 0 002.048-1.235l-.035-2.177a9.511 9.511 0 002.812-7.463zm-4.16 6.534a.794.794 0 00-.26.604l.034 2.152-1.914-1.048a.811.811 0 00-.644-.055 7.94 7.94 0 112.784-1.653z"
        fill="#fff"
      />
      <path
        d="M29.748 20.565l-1.694-1.236a.977.977 0 00-.736-.178.969.969 0 00-.646.393l-.524.716c-.027.038-.017.003-.03.05-.002.005-.031.045-.125.06-.159.024-.633-.006-1.66-.826l-.098-.072c-1.08-.72-1.253-1.162-1.278-1.32-.012-.082.008-.121.005-.124.035-.022.025-.022.052-.057l.524-.716a.99.99 0 00-.215-1.384L21.6 14.611a.99.99 0 00-1.382.215l-.529.727a2.534 2.534 0 00-.329 2.286c.408 1.19 1.449 2.453 3.095 3.758.023.027.047.05.077.072.042.03.084.059.126.086l.121.094c.027.022.06.04.091.052 1.746 1.17 3.266 1.775 4.524 1.802h.05c.78 0 1.525-.383 1.997-1.033l.53-.727a.977.977 0 00-.223-1.38zM9.172 27.007l-.047 2.938a.677.677 0 001.002.605l2.605-1.428a10.138 10.138 0 005.572.288.256.256 0 00.064-.476 10.672 10.672 0 01-5.57-8.9 10.669 10.669 0 015.722-9.891.256.256 0 00-.05-.476 10.15 10.15 0 00-9.298 17.34z"
        fill="#fff"
      />
      <defs>
        <linearGradient
          id="paint0_linear_21238_5679"
          x1={8.25}
          y1={4.5}
          x2={35.25}
          y2={36.5}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#75CD88" />
          <stop offset={1} stopColor="#05761B" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default ConectaZapColoredIcon;
